/**
 * swisspostsolutionscms - JSON API
 * This is a JSON API compliant implementation
 *
 * The version of the OpenAPI document: Versioning not supported
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { FileFile } from '../model/fileFile';
// @ts-ignore
import { FileFileEntityRelationshipsUidGet200Response } from '../model/fileFileEntityRelationshipsUidGet200Response';
// @ts-ignore
import { FileSchema } from '../model/fileSchema';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { ContentConfiguration }                                     from '../configuration';



@Injectable({
  providedIn: 'root'
})
export class FileService {

    protected basePath = 'https://cms.spsglobal.com/jsonapi';
    public defaultHeaders = new HttpHeaders();
    public configuration = new ContentConfiguration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string|string[], @Optional() configuration: ContentConfiguration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (Array.isArray(basePath) && basePath.length > 0) {
                basePath = basePath[0];
            }

            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }


    // @ts-ignore
    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, (value as Date).toISOString().substr(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * View (File)
     * &lt;em class&#x3D;\&quot;placeholder\&quot;&gt;&lt;a href&#x3D;\&quot;http://jsonapi.org/format/#fetching\&quot;&gt;Individual endpoint&lt;/a&gt;&lt;/em&gt; for the file--file resource type. The individual endpoint contains a &lt;em class&#x3D;\&quot;placeholder\&quot;&gt;&lt;a href&#x3D;\&quot;http://jsonapi.org/format/#document-resource-objects\&quot;&gt;resource object&lt;/a&gt;&lt;/em&gt; with the data for a particular resource or entity.
     * @param entity The uuid of the file file
     * @param include include relation data
     * @param filterFieldPathValue filter by path
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public fileFileEntityGet(entity: string, include?: string, filterFieldPathValue?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/vnd.api+json', context?: HttpContext}): Observable<FileFile>;
    public fileFileEntityGet(entity: string, include?: string, filterFieldPathValue?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/vnd.api+json', context?: HttpContext}): Observable<HttpResponse<FileFile>>;
    public fileFileEntityGet(entity: string, include?: string, filterFieldPathValue?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/vnd.api+json', context?: HttpContext}): Observable<HttpEvent<FileFile>>;
    public fileFileEntityGet(entity: string, include?: string, filterFieldPathValue?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/vnd.api+json', context?: HttpContext}): Observable<any> {
        if (entity === null || entity === undefined) {
            throw new Error('Required parameter entity was null or undefined when calling fileFileEntityGet.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (include !== undefined && include !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>include, 'include');
        }
        if (filterFieldPathValue !== undefined && filterFieldPathValue !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>filterFieldPathValue, 'filter[field_path][value]');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/vnd.api+json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/file/file/${this.configuration.encodeParam({name: "entity", value: entity, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}`;
        return this.httpClient.request<FileFile>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Relationship: uid (User)
     * &lt;em class&#x3D;\&quot;placeholder\&quot;&gt;&lt;a href&#x3D;\&quot;https://jsonapi.org/format/#fetching-relationships\&quot;&gt;Relationship endpoint&lt;/a&gt;&lt;/em&gt; for the user--user resource type through the &lt;em class&#x3D;\&quot;placeholder\&quot;&gt;uid&lt;/em&gt; relationship. The relationship endpoint contains a &lt;em class&#x3D;\&quot;placeholder\&quot;&gt;&lt;a href&#x3D;\&quot;https://jsonapi.org/format/#document-resource-identifier-objects\&quot;&gt;resource identifier object&lt;/a&gt;&lt;/em&gt; with the data for a particular relationship.
     * @param entity The uuid of the file file
     * @param include include relation data
     * @param filterFieldPathValue filter by path
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public fileFileEntityRelationshipsUidGet(entity: string, include?: string, filterFieldPathValue?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/vnd.api+json', context?: HttpContext}): Observable<FileFileEntityRelationshipsUidGet200Response>;
    public fileFileEntityRelationshipsUidGet(entity: string, include?: string, filterFieldPathValue?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/vnd.api+json', context?: HttpContext}): Observable<HttpResponse<FileFileEntityRelationshipsUidGet200Response>>;
    public fileFileEntityRelationshipsUidGet(entity: string, include?: string, filterFieldPathValue?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/vnd.api+json', context?: HttpContext}): Observable<HttpEvent<FileFileEntityRelationshipsUidGet200Response>>;
    public fileFileEntityRelationshipsUidGet(entity: string, include?: string, filterFieldPathValue?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/vnd.api+json', context?: HttpContext}): Observable<any> {
        if (entity === null || entity === undefined) {
            throw new Error('Required parameter entity was null or undefined when calling fileFileEntityRelationshipsUidGet.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (include !== undefined && include !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>include, 'include');
        }
        if (filterFieldPathValue !== undefined && filterFieldPathValue !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>filterFieldPathValue, 'filter[field_path][value]');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/vnd.api+json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/file/file/${this.configuration.encodeParam({name: "entity", value: entity, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/relationships/uid`;
        return this.httpClient.request<FileFileEntityRelationshipsUidGet200Response>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * List (File)
     * &lt;em class&#x3D;\&quot;placeholder\&quot;&gt;&lt;a href&#x3D;\&quot;http://jsonapi.org/format/#fetching\&quot;&gt;Collection endpoint&lt;/a&gt;&lt;/em&gt; for the file--file resource type. Collections are a list of &lt;em class&#x3D;\&quot;placeholder\&quot;&gt;&lt;a href&#x3D;\&quot;http://jsonapi.org/format/#document-resource-objects\&quot;&gt;resource objects&lt;/a&gt;&lt;/em&gt; for a particular resource type. In the JSON API module for Drupal all collections are homogeneous, which means that all the items in a collection are of the same type.
     * @param filter The JSON:API module has some of the most robust and feature-rich filtering features around. All of that power comes with a bit of a learning curve though. &lt;a href&#x3D;\&quot;https://www.drupal.org/docs/8/modules/jsonapi/filtering\&quot;&gt;Learn more in the documentation&lt;/a&gt;.
     * @param sort The JSON:API module allows you to sort collections based on properties in the resource or in nested resources. &lt;a href&#x3D;\&quot;https://www.drupal.org/docs/8/modules/jsonapi/sorting\&quot;&gt;Learn more in the documentation&lt;/a&gt;.
     * @param page Pagination can be a deceptively complex topic. It\&#39;s easy to fall into traps and not follow best-practices. &lt;a href&#x3D;\&quot;https://www.drupal.org/docs/8/modules/jsonapi/pagination\&quot;&gt;Learn more in the documentation&lt;/a&gt;.
     * @param include Embed related entities in the response. For example: use a query string like &lt;code&gt;?include&#x3D;comments.author&lt;/code&gt; to include all the entities referenced by &lt;code&gt;comments&lt;/code&gt; and all the entities referenced by &lt;code&gt;author&lt;/code&gt; on those entities!. &lt;a href&#x3D;\&quot;https://www.drupal.org/docs/8/modules/jsonapi/includes\&quot;&gt;Learn more in the documentation&lt;/a&gt;.
     * @param filterFieldPathValue filter by path
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public fileFileGet(filter?: Array<string>, sort?: Array<string>, page?: Array<string>, include?: string, filterFieldPathValue?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/vnd.api+json', context?: HttpContext}): Observable<FileSchema>;
    public fileFileGet(filter?: Array<string>, sort?: Array<string>, page?: Array<string>, include?: string, filterFieldPathValue?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/vnd.api+json', context?: HttpContext}): Observable<HttpResponse<FileSchema>>;
    public fileFileGet(filter?: Array<string>, sort?: Array<string>, page?: Array<string>, include?: string, filterFieldPathValue?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/vnd.api+json', context?: HttpContext}): Observable<HttpEvent<FileSchema>>;
    public fileFileGet(filter?: Array<string>, sort?: Array<string>, page?: Array<string>, include?: string, filterFieldPathValue?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/vnd.api+json', context?: HttpContext}): Observable<any> {

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (filter) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                [...filter].join(COLLECTION_FORMATS['csv']), 'filter');
        }
        if (sort) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                [...sort].join(COLLECTION_FORMATS['csv']), 'sort');
        }
        if (page) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                [...page].join(COLLECTION_FORMATS['csv']), 'page');
        }
        if (include !== undefined && include !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>include, 'include');
        }
        if (filterFieldPathValue !== undefined && filterFieldPathValue !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>filterFieldPathValue, 'filter[field_path][value]');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/vnd.api+json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/file/file`;
        return this.httpClient.request<FileSchema>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
